document.addEventListener('DOMContentLoaded', function () {
    var selectAll = document.getElementById('selectAllInvoices');
    var invoiceInputs = document.querySelectorAll('.invoice-table tbody input[type="checkbox"]');
    var groupShipments = document.getElementById('groupInvoiceShipments');
    var groupLabels = document.getElementById('groupInvoiceLabels');
    var selectedInvoices = function () {
        var invoices = [];
        invoiceInputs.forEach(function (input) {
            if (input.checked && isNaN(parseInt(input.getAttribute('data-shipment') || ''))) {
                invoices.push(parseInt(input.value));
            }
        });
        return invoices;
    };
    var selectedShipments = function () {
        var shipments = [];
        invoiceInputs.forEach(function (input) {
            var shipment = parseInt(input.getAttribute('data-shipment') || '');
            if (input.checked && shipment > 0) {
                shipments.push(shipment);
            }
        });
        return shipments;
    };
    var updateGroupActions = function () {
        var invoices = selectedInvoices();
        var shipments = selectedShipments();
        if (invoices.length > 0) {
            groupShipments.style.display = 'inline-block';
            var shipmentBase = groupShipments.getAttribute('data-href');
            groupShipments.href = shipmentBase ? shipmentBase.replace(/REPLACE/, invoices.join(',')) : '';
        }
        else {
            groupShipments.style.display = 'none';
        }
        if (shipments.length > 0) {
            groupLabels.style.display = 'inline-block';
            var labelBase = groupLabels.getAttribute('data-href');
            groupLabels.href = labelBase ? labelBase.replace(/REPLACE/, shipments.join(',')) : '';
        }
        else {
            groupLabels.style.display = 'none';
        }
    };
    if (selectAll) {
        selectAll.addEventListener('click', function () {
            var _this = this;
            invoiceInputs.forEach(function (el) {
                el.checked = _this.checked;
            });
            updateGroupActions();
        });
    }
    document.querySelectorAll('.invoice-table tbody tr').forEach(function (tr) {
        tr.addEventListener('click', function () {
            var input = this.querySelector('input[type="checkbox"]');
            input.checked = !input.checked;
            input.dispatchEvent(new Event('click'));
        });
        tr.querySelectorAll('a').forEach(function (a) {
            a.addEventListener('click', function (ev) {
                ev.stopPropagation();
            });
        });
    });
    invoiceInputs.forEach(function (input) {
        input.addEventListener('click', updateGroupActions);
    });
});
export {};
